module.exports = "/img/18.474d50.webp";